const tabs = () => {

    gsap.registerPlugin(ScrollTrigger);

    const tabButtons = document.querySelectorAll('.projects__tab');
    const tabContent = document.querySelectorAll('.projects__content');

    let toggleBlock = gsap.to('.projects__content', {
        height: 'auto',
        paused: true,
        autoAlpha: 1,
        duration: 1,
        ease: 'power1.out'
    })

    function removeClases () {
        tabButtons.forEach((item) => {
            item.classList.remove('active');

        })
        tabContent.forEach((item) => {
            item.classList.remove('active')
            let toggleBlock = gsap.to(item, {
                height: 0,
                paused: true,
                autoAlpha: 0,
                duration: 1,
                ease: 'power1.out'
            })
            toggleBlock.play();
        })
    }

    function showContent (i) {
        tabButtons[i].classList.add('active');
        tabContent[i].classList.add('active');
        let toggleBlock = gsap.to(tabContent[i], {
            height: 'auto',
            paused: true,
            autoAlpha: 1,
            duration: 1,
            ease: 'power1.out'
        })
        toggleBlock.play();
    }

 

    const openTabContainer = () => {
        tabButtons.forEach((item, i) => {
            let toggleBlock = gsap.to('.projects__tab-wrap', {
                height: 'auto',
                paused: true,
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })

           
            tabButtons.forEach(item => {
                item.addEventListener('click', () => {
                    console.log(window.getComputedStyle(document.querySelector('.projects__tab-wrap')).height)
                    window.getComputedStyle(document.querySelector('.projects__tab-wrap')).height == '85px' ? toggleBlock.play() : toggleBlock.reverse();
                })
            })
        })
       
    }

    // const showButtons = () => {
    //     tabButtons.forEach((item, i) => {
    //         let show = gsap.to(item, {
    //             opacity: 1,
    //             paused: true,
    //         })

           
    //         tabButtons.forEach(item => {
    //             item.addEventListener('click', () => {
    //                 console.log(window.getComputedStyle(document.querySelector('.projects__tabs')).height)
    //                 window.getComputedStyle(document.querySelector('.projects__tabs')).height == '100px' ? show.play() : show.reverse();
    //             })
    //         })
    //     })
    // }

    let mm = gsap.matchMedia();
    mm.add({
      isMobile: "(max-width: 576px)",
      isDesktop: "(min-width: 577px)"
    }, (context) => {
      let { isMobile, isDesktop } = context.conditions;
        

        tabButtons.forEach((item, i) => {
            item.addEventListener('click', () => {
                removeClases();
                showContent(i);
            })
            isMobile ? openTabContainer() : null;

            // isMobile ? showButtons() : null
        })
    

    })

   
}

module.exports = tabs;